import TextField from '@mui/material/TextField';
import Dialog from 'components/Dialog';
import React from 'react';

const Component = props => {
  // The props are the initial values, the state is what the person typed. They
  // are aliased rather than renamed because `code` and `designation` are the
  // scenario's own column names, and those are what the state should be called.
  const { code: initialCode, description: initialDesignation, open } = props;
  const { handleClose, handleSubmit } = props;

  const [code, setCode] = React.useState(initialCode);
  const [designation, setDesignation] = React.useState(initialDesignation);
  const [notes, setNotes] = React.useState('');

  const handleChangeCode = e => setCode(e.target.value);
  const handleChangeDesignation = e => setDesignation(e.target.value);
  const handleChangeNotes = e => setNotes(e.target.value);

  const createScenario = () => {
    handleSubmit(code, designation, notes);
  };

  return (
    <Dialog
      maxWidth={'md'}
      header='Criar Cenário'
      open={open}
      onClose={handleClose}
      onConfirm={createScenario}
    >
      <TextField
        autoFocus
        id="code"
        label="Codigo cenário"
        type="code"
        fullWidth
        multiline
        value={code}
        style={{ marginBottom: 10 }}
        onChange={handleChangeCode}
      />
      <TextField
        id="designation"
        label="Designação cenário"
        type="designation"
        fullWidth
        multiline
        value={designation}
        style={{ marginBottom: 10 }}
        onChange={handleChangeDesignation}
      />
      <TextField
        id="notes"
        label="Notas cenário"
        type="notes"
        fullWidth
        multiline
        value={notes}
        style={{ marginBottom: 10 }}
        onChange={handleChangeNotes}
      />
    </Dialog>
  );
};

export default Component;
